import React from "react";
import Sidebar from "react-sidebar";
import { X, MoreVertical } from "react-feather";
import logo from "components/Navbars/img/sm-logo.png";
import userimage from "components/Navbars/img/userimage.png";
import { getUserSingleUserJourneyAction } from "store/notifcation";
import { connect } from "react-redux";
import moment from "moment";
class App extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      sidebarOpen: true,
      userData: this.props.notification,
    };
    this.onSetSidebarOpen = this.onSetSidebarOpen.bind(this);
  }

  onSetSidebarOpen(open) {
    this.setState({ sidebarOpen: open });
  }

  render() {
    // console.log(this.props.notification)
    return (
      <Sidebar
        rootClassName="h-0"
        sidebarClassName="sidebar-33 mob-rounded-none rounded-t-l-12px p-6 fixed"
        pullRight
        sidebar={
          <div>
            <div className="flex justify-between">
              <h1 className="font-bold fsize20">Notifications</h1>
              <X className="cursor-pointer" />
            </div>

            <div>
              {this.state.userData &&
                this.state.userData.Data &&
                this.state.userData.Data.userJourneydataGeneral
                  .slice(0, 5)
                  .map((value, index) => (
                    <div className="content mt-4" key={index}>
                      <div className="rounded-12px bgF7F7F7 p-2 mb-2">
                        <div className="flex">
                          <div className="w-5/6	pr-2">
                            {" "}
                            <div className="flex justify-between">
                              <div className="flex items-center">
                                <img src={logo} alt="logo" />
                                <h1 className="fsize14 line-h18 font-bold ml-2">
                                  {value.m_Title}
                                </h1>
                              </div>
                            </div>
                            <div className="mt-1 pl-10 ">
                              <p className="fsize12 line-h18 text-black">
                                {value.m_Description}
                              </p>

                              <p className="fsize12 text-black opacity-50per pt-2">
                                {moment(value.m_createdDate).fromNow()}
                              </p>
                            </div>
                          </div>
                          <div className="w-4/12	 relative">
                            <img
                              src={userimage}
                              alt="user"
                              className="w-78px h-70px mt-3 ml-2"
                            />
                            <MoreVertical
                              width="20px"
                              height="20px"
                              className="absolute top-0 right-0"
                            />
                          </div>
                        </div>
                      </div>

                      <div className="border-b-not my-3"></div>
                    </div>
                  ))}
              <div className="flex justify-center mt-4 cursor-pointer">
                <p className="applynow-t ml-2 fsize14">View all</p>
              </div>
            </div>
          </div>
        }
        open={this.props.shownotification}
        onSetOpen={this.onSetSidebarOpen}
        styles={{ sidebar: { background: "white" } }}
      >
         <div />
        {/* <button onClick={() => this.onSetSidebarOpen(true)}>
          Open sidebar
        </button> */}
      </Sidebar>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    Auth: state.Auth.user,
    notification: state.NOTIFICATION.notification.SINGLEUSERJOURNEY,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getUserSingleUserJourneyAction: async (payload) =>
      await dispatch(getUserSingleUserJourneyAction(payload)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(App);
